module.exports = __webpack_public_path__ + "fonts/judson-gm9r.518a9ff6.ttf";